<template>
  <el-dialog
    class="form-modal"
    :visible.sync="visible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2 mb-0">Voicemail</h1>
        <div class="modal-actions col-2">
          <el-button type="default" @click="close">Cancel</el-button>
        </div>
      </div>
    </div>

    <div class="voicemail-list">
      <template v-if="voicemails && voicemails.length">
        <voicemail-cell
          v-for="vm of voicemails"
          :key="vm.id"
          :voicemail="vm"
          @playOperation="playVoicemail"
          @deleteOperation="deleteVoicemail"
        />
      </template>
      <h2 v-else>Your voicemail box is empty.</h2>
    </div>

    <voicemail-player
      :visible="vmPlayerVisible"
      :src="vmSrc"
      :voicemail="selectedVm"
      v-loading="voicemailProcessing"
      @closeOperation="vmPlayerVisible = false"
    />
  </el-dialog>
</template>

<script>
import VoicemailCell from "./voicemailCell.vue";
import VoicemailPlayer from "./voicemailPlayer.vue";
import { hostServer } from "@/feathers/feathers-client";

export default {
  name: "VoxoMobileVoicemailList",

  props: {
    visible: { required: true },
    voicemails: { required: true },
    userParams: { required: true },
    authKey: { required: true },
  },

  components: { VoicemailCell, VoicemailPlayer },

  data() {
    return {
      voicemailProcessing: false,
      vmPlayerVisible: false,
      selectedVm: {},
      vmSrc: "",
    };
  },

  methods: {
    close() {
      this.$emit("closeOperation");
    },

    playVoicemail(voicemail) {
      this.vmPlayerVisible = true;
      this.selectedVm = voicemail;
      const { username, noAuthKey } = this.userParams;

      this.voicemailProcessing = true;
      fetch(
        `https://api.voxo.co/mobile-api-vm-temp/${this.selectedVm.id}?noAuth=${noAuthKey}&user=${username}`
      )
        .then((res) => res.json())
        .then((res) => {
          this.vmSrc = res.recording;
          this.voicemailProcessing = false;
          if (voicemail.status === "unread") {
            this.updateVoicemail(voicemail.id);
          }
        })
        .catch(() => {
          this.voicemailProcessing = false;
        });
    },

    updateVoicemail(id) {
      const { te_code, ext } = this.userParams;

      fetch(
        `${hostServer}/voxo-mobile/update-voicemail_${this.authKey}?te_code=${te_code}&ext=${ext}&id=${id}`
      ).then((res) => {
        if (`${res.status}`.startsWith("2")) {
          this.$emit("voicemailRead", id);
        }
      });
    },

    deleteVoicemail(id) {
      this.$confirm("Delete Voicemail?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      })
        .then(() => {
          this.voicemailProcessing = true;

          fetch(
            `${hostServer}/voxo-mobile/delete-voicemail_${this.authKey}?id=${id}`
          )
            .then((res) => {
              this.voicemailProcessing = false;
              if (`${res.status}`.startsWith("2")) {
                this.$notify({
                  title: "Success",
                  message: "Deleted voicemail successfully.",
                  type: "success",
                });

                this.$emit("voicemailDeleted", id);
              }
            })
            .catch(() => {
              this.voicemailProcessing = false;
            });
        })
        .catch(() => true);
    },
  },
};
</script>

<style lang="scss" scoped>
.voicemail-list {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 0;
}
</style>
